import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

export const ViewDetailsButton = styled(Button, {
  name: 'ViewDetailsButton',
  slot: 'Root',
  skipSx: true,
})`
  color: #19305a;
  font-family: 'Source Sans Pro';
  font-size: 13px;
  padding-left: 8px;
`
